import PropTypes from 'prop-types';

export const countryType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  iso_3166_2: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/types/index.js